import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Observable, throwError, EMPTY, TimeoutError } from "rxjs";
import { finalize, catchError, timeout, mergeMap } from "rxjs/operators";
import { Injectable } from '@angular/core';
import { SegovSigepoSpinnerStdComponent } from "../controls/segov-sigepo-spinner.std/segov-sigepo-spinner.std.component";
import { CommonMessages } from "./common.messages";
import { Store } from "@ngrx/store";
import { ToastState } from "../stateManagement/reducers/toast.reducer";
import { toastShow } from "../stateManagement/actions/toast.action";
import { ToastModel, ToastType } from "../domain/models/toast.model";
import { removeBearerToken } from "./bearer.token";
import { ToastrMessages } from "./toastr.messages";
import { environment } from "../environments/environment";
import { AutenticacaoService } from "../services/autenticacao.service";
import { SKIP_GLOBAL_ERROR_TOAST } from "../services/base.service";

@Injectable()
export class RequestInterceptor implements HttpInterceptor {

  private requestsCount = 0;

  constructor(
    private storeToast: Store<{ toastState: ToastState }>,
    private autenticacaoService: AutenticacaoService,
    ) {
    }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    this.requestsCount++;
    const timeoutDuration = environment.requestTimeout;
    if(req.url.toLocaleLowerCase().includes('autenticacao')){
      SegovSigepoSpinnerStdComponent.show();

      return next.handle(req).pipe(
        timeout(timeoutDuration),
        catchError(error => {
          this.storeToast.dispatch(toastShow({
            toastModel: new ToastModel(
              CommonMessages.Alert,
              ToastrMessages.ConteudoIndisponivel,
              ToastType.Error
            )
          }));

          return throwError(() => error);
        }),
        finalize(() => {
          this.requestsCount--;

          if (this.requestsCount == 0)
            SegovSigepoSpinnerStdComponent.hide()
        })
      );
    }

    return this.autenticacaoService.ObterTokenAtual().pipe(
      mergeMap((token) => {
        if(token === null || token == '')
          throw new Error("Token vazio");
        else
          return this.handleRequest(req, next, timeoutDuration, token);
      }),
      catchError((err: HttpErrorResponse) => {
        if (err.status === 401) {
          this.autenticacaoService.tokenKey = '';
          removeBearerToken();
        }
        return throwError(() => err);
      }),
      finalize(() => {
        this.requestsCount--;

        if (this.requestsCount == 0)
          SegovSigepoSpinnerStdComponent.hide()
      })
    )
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private handleRequest(req: HttpRequest<any>, next: HttpHandler, timeoutDuration: number, token: string) {
    SegovSigepoSpinnerStdComponent.show();

    return next.handle(
      req.clone(
        {setHeaders: {Authorization: `Bearer ${token}`}}
        )
      ).pipe(
      timeout(timeoutDuration),
      catchError(error => {
        if (error.status == 401) {
          this.autenticacaoService.tokenKey = '';
          removeBearerToken();
        }

        if (req.context.get(SKIP_GLOBAL_ERROR_TOAST))
          return throwError(() => error);

        if (error instanceof TimeoutError) {
          this.storeToast.dispatch(toastShow({
            toastModel: new ToastModel(
              CommonMessages.Alert,
              ToastrMessages.ConteudoIndisponivel,
              ToastType.Error
            )
          }));
        }

        if (error.status == 429) {
          this.storeToast.dispatch(toastShow({
            toastModel: new ToastModel(
              CommonMessages.Alert,
              ToastrMessages.MuitosAcessos,
              ToastType.Error)
          }));
          return EMPTY;
        }

        if (error.status >= 402) {
          this.storeToast.dispatch(toastShow({
            toastModel: new ToastModel(
              CommonMessages.Alert,
              ToastrMessages.ConteudoIndisponivel,
              ToastType.Error)
          }));
          return EMPTY;
        }

        return throwError(() => error);
      })
    );
  }
}
